var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:({backgroundColor: _vm.color})},[_c('span',[_vm._v(_vm._s(_vm.texto))])])
}
var staticRenderFns = []

export { render, staticRenderFns }